import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAIL,
  REGISTER_USER_FAIL,
  REGISTER_USER_SUCCESS,
  OTP_VERIFY,
  RESND_OTP,
  USER_PROFILE,
  REGISTER_USER,
  PINCODE_ADDRESS,
  UPDATE_USER,
} from "./types";
import {
  GET_OTP,
  VERIFY_OTP,
  USER_REGISTER_API,
  USER_PINCODE,
  UPDATE_USER_API,
} from "../../Api/EndPoints";
import { APIClient } from "../../Api/APIClient";
import * as Models from "../../models";
/**************************************Login ****************************************************/
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export function userLogin(req: Models.SignInAcruRequest) {
  let loginURL =
    API_BASE_URL +
    GET_OTP +
    req.mobile +
    "/" +
    req.partner +
    "/" +
    req.terms_accepted +
    "/" +
    req.hashCode;
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: LOGIN_USER });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .get(loginURL, "", "")
          .then((response: any) => {
            let result = response;
            loginSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            loginFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function verifyOTP(req: Models.OTPVerifyRequest) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: OTP_VERIFY });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .post(API_BASE_URL + VERIFY_OTP, JSON.stringify(req), "")
          .then((response: any) => {
            let result = response;
            loginSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            loginFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function resendOTP(req: Models.SignInAcruRequest) {
  let resendOtp =
    API_BASE_URL +
    GET_OTP +
    req.mobile +
    "/" +
    req.partner +
    "/" +
    req.terms_accepted +
    "/" +
    req.hashCode;
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: RESND_OTP });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .get(resendOtp, "", "")
          .then((response: any) => {
            let result = response;
            loginSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            loginFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function userRegister(req: Models.RegisterRequest, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: REGISTER_USER });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(
            API_BASE_URL + USER_REGISTER_API,
            JSON.stringify(req),
            token
          )
          .then((response: any) => {
            let result = response;

            registerSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            registerFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}
//update
export function userInfoUpdate(req: Models.UpdateUserRequest, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: UPDATE_USER });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + UPDATE_USER_API, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;

            registerSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            registerFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function userPincode(req: Models.PincodeRequest, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: PINCODE_ADDRESS });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + USER_PINCODE, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;

            registerSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            registerFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}
const loginFailed = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: LOGIN_USER_FAIL,
    payload: errorMessage,
  });
};

const loginSuccess = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  message: any
) => {
  dispatch({
    type: LOGIN_USER_SUCCESS,
    payload: message,
  });
};

const registerFailed = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: REGISTER_USER_FAIL,
    payload: errorMessage,
  });
};

const registerSuccess = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  message: any
) => {
  dispatch({
    type: REGISTER_USER_SUCCESS,
    payload: message,
  });
};
